import { Component, EventEmitter, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { WorkspaceComponent } from 'app/components/core/workspace/workspace.component';
import { ReasonSelectComponent } from 'components/input/reason-select/reason-select.component';
import { InputStateDirective } from 'directives/input-state.directive';
import { ValidationDirective } from 'directives/validation.directive';
import { ReasonType } from 'enums/ReasonType';
import { Layout } from 'modules/layout';
import { TranslatePipe } from 'pipes/translate.pipe';
import { FormValidationService } from 'services/form-validation.service';
import { SalesService } from 'services/sales.service';

@Component({
	selector: 'create-order-cancellation',
	templateUrl: './create-order-cancellation.component.html',
	providers: [FormValidationService],
	imports: [Layout, ReasonSelectComponent, InputStateDirective, FormsModule, ValidationDirective, TranslatePipe]
})
export class CreateOrderCancellationComponent {

	@Output() cancellationCreated = new EventEmitter<string>();

	comment = '';	
	selectedReasonId?: string;
	orderId!: string;
	reasonType = ReasonType;

	constructor(private salesService: SalesService, 
		private workspace: WorkspaceComponent) {
	}

	createOrderCancellation() {
		this.salesService.createOrderCancellation(this.orderId, this.comment, this.selectedReasonId!).then(() => {
			this.workspace.closePopup();
			this.cancellationCreated.emit(this.orderId);
		});
	}
}
